import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  Input,
  Inject, Optional
} from '@angular/core';
import { FlowManagerService } from '../../services/flow-manager.service';
import { FlowWebSocketsService } from '../../services/flowBuilder/flow-web-sockets.service';
import { FlowBuilderService } from '../../services/flowBuilder/flow-builder.service';
import { ZoomService } from '../../services/flowBuilder/zoom.service';
import { OnEnterEvent } from '../flow-node/flow-node.component';
import { KeyEventsService } from '../../services/flowBuilder/key-events.service';
import map from 'lodash/map';
import find from 'lodash/find';
import {Subscription} from 'rxjs';
import { UserStoreService } from '../../../../core/services/store/UserStore/user-store.service';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {Router} from "@angular/router";

@Component({
  selector: 'flow-step-selection',
  templateUrl: './flow-step-selection.component.html',
  styleUrls: ['./flow-step-selection.component.scss'],
})

export class FlowStepSelectionComponent implements OnInit, AfterViewInit, OnDestroy {
  constructor(
    public Router: Router,
    public flowManagerService: FlowManagerService,
    public flowWebSocket: FlowWebSocketsService,
    public flowBuilderService: FlowBuilderService,
    public zoomService: ZoomService,
    public userStore: UserStoreService,
    private keyEventsService: KeyEventsService
  ) {}

  breadcrumbs: any;
  flow: any;
  flowToRebuild: any;
  flowData: any;
  flowSelected: Boolean = false;
  isScrollZoom: Boolean;
  searchValue: String;
  selectedNode: String;
  nodeClickedEvent: any;
  selectedFlow: any = null;
  getFlowMetaDataByIdSubscription: Subscription;
  forceDisabled: boolean;

  onNodeEvent: OnEnterEvent;

  @Input() selectedValue: any;
  @Input() searchForValue: string;
  @Input() botId: string;
  @Input() disableFilter = false;

  @Output() closeModal = new EventEmitter();

  @ViewChild('flowComponent') flowComponent: ElementRef;

  ngOnInit() {
    this.flowBuilderService.setModalOpen(true);
    this.setupSelection();
    this.forRoutingPage();
  }

  ngAfterViewInit() {
    this.setArea();
    this.flowToRebuild = this.flowBuilderService.getFlow();
    let currFlow = this.flowBuilderService.getCurrFlow();

    this.forRoutingPage();

    window.setTimeout(() => {
      this.buildFlow(this.flowToRebuild);
    }, 100);

    this.setStartBreadcrumbs(currFlow);

    if (!this.selectedValue.selected || this.selectedValue.selected === '-Not Selected-') {
      this.setSelectedNode(this.selectedValue.step);
    } else {
      const selectedFlow = this.selectedValue.selected.split(':');
      if (selectedFlow && selectedFlow.length === 2) {
        this.getFlowData(selectedFlow[0], () => {
          this.setSelectedNode(selectedFlow[1]);
        });
      }
    }

    this.setSelectedNode(this.selectedValue.step);

    if (this.flowComponent) {
      this.keyEventsService.setKeyFunctionality(
        this.flowComponent.nativeElement,
        'dragAreaModal',
        'drawAreaModal',
        this.onNodeEvent,
        'searchStepFlowStepSelection');
    }
  }

  forRoutingPage() {
    if(this.Router.url.includes('routing')) {
      this.flowBuilderService.setCurrFlow({name:'',path: undefined, title:'',start:{type: 'start', next: 'step1'}});
      this.flowToRebuild = this.flowBuilderService.getCurrFlow();
    }
  }

  ngOnDestroy(): void {
    this.keyEventsService.unsubscribeKeyEventsSubscriptions();
    if (this.getFlowMetaDataByIdSubscription) {
      this.getFlowMetaDataByIdSubscription.unsubscribe();
    }
  }

  setupSelection() {
    if (this.selectedValue['selected'] !== 'NextStep') {
      const flowId = this.selectedValue['selected'].substring(0, this.selectedValue['selected'].lastIndexOf(':'));
      const flowToDisplay = {
        'name': '',
        'path': '',
        'title': ''
      };
      this.getFlowMetaDataByIdSubscription = this.flowManagerService.getFlowMetaDataById(flowId).subscribe(
          flowData => {
            flowToDisplay.name = flowData.flowId;
            flowToDisplay.path = flowData.directory.substring(0, flowData.directory.lastIndexOf('/')) + '/' + flowData.flowId;
            flowToDisplay.title = flowData.flowName;
            this.flowClicked(flowToDisplay);
            this.forceDisabled = true;
          }
      );
    }
  }

  setArea() {
    const area = document.querySelector('#drawAreaModal') as HTMLDivElement;
    this.flowBuilderService.setFlowArea = area;
    this.zoomService.resetZoom();
    this.zoomService.setPanZoomInstance = area;
    const zoomType = this.userStore.getZoomPreference;
    this.zoomService.setZoomType(zoomType);
    this.isScrollZoom = zoomType === 'panZoom';
    this.zoomService.setZoom(50);
  }

  setStartBreadcrumbs(flow) {
    const selectedValue = this.selectedValue.selected;
    if (selectedValue) {
      const selectedValueArr = selectedValue.split(':');
      if (selectedValueArr && selectedValueArr.length === 2) {
        const flowId = selectedValueArr[0];
        this.flowManagerService.getFlowMetaData().subscribe(data => {
          const selectedFlowData = find(data, { flowId });
          const selectedFlowDataArr = selectedFlowData.directory.split('/');
          this.breadcrumbs = map(selectedFlowDataArr, (item, i) => {
            return (i === selectedFlowDataArr.length - 1)
              ? { title: item, type: 'flow'}
              : { title: item, type: 'folder'};
          });
        });
      } else {
        this.setBreadcrumbs(flow);
      }
    }
  }

  setBreadcrumbs(flow) {
    if (flow && flow.path) {
      const pathArr = flow.path.split('/');
      this.breadcrumbs = map(pathArr, item => {
        return (item === flow.name)
          ? { title: flow.title, type: 'flow'}
          : { title: item, type: 'folder'};
      });
    } else {
      this.breadcrumbs = [{ title: '__NEW_FLOW__', type: 'flow'}];
    }
  }

  flowClicked(e) {
    this.zoomService.resetZoom();
    this.zoomService.setZoom(50);
    this.getFlowData(e.name);
    this.setBreadcrumbs(e);
    this.selectedFlow = e;
    this.resetSelectedNode();
  }

  getFlowData(flowName, callback?) {
    this.flowBuilderService.resetFlow();
    this.flowManagerService.getFlow(flowName).subscribe(
      (flow) => {
        this.flow = flow;
      },
      () => {
        alert('failed to load flow');
      },
      () => {
        this.buildFlow(this.flow, callback);
      }
    );
  }

  buildFlow(flow, callback?) {
    this.flowBuilderService.buildFlow(flow);
    this.flowSelected = true;
    if (callback) {
      callback();
    }
  }

  searchForChange(event: any) {
    this.searchForValue = event.value;
  }

  nodeClick(e) {
    this.forceDisabled = false;
    this.setSelectedNode(e.stepId);
    this.nodeClickedEvent = e;
  }

  onNode(e) {
    this.onNodeEvent = e;
  }

  setSelectedNode(stepId) {
    this.selectedNode = stepId;
  }

  resetSelectedNode() {
    this.selectedNode = '';
    this.nodeClickedEvent = null;
  }

  close(value?) {
    this.flowBuilderService.setModalOpen(false);
    this.flowSelected = false;
    this.selectedFlow = null;
    this.zoomService.resetZoom();
    window.setTimeout(() => {
      const area = document.querySelector('#drawArea') as HTMLDivElement;
      if (area != null) {
      this.flowBuilderService.setFlowArea = area;
      this.zoomService.setPanZoomInstance = area;
      }
      const zoomType = this.userStore.getZoomPreference;
      this.zoomService.setZoomType(zoomType);
      this.isScrollZoom = zoomType === 'panZoom';
      if (this.flowToRebuild) {
        this.buildFlow(this.flowToRebuild, () => {
          this.closeModal.emit(value);
        });
      }
    }, 100);
  }

  getIsModalOpen() {
    return this.flowBuilderService.getModalOpen();
  }

  search() {
    if (this.searchValue && this.searchValue.length > 0) {
      // @ts-ignore
      this.zoomService.scrollTo(this.searchValue, 'dragAreaModal');
      this.zoomService.setZoom(50);
      this.clearSearchValue();
    }
  }

  clearSearchValue() {
    this.searchValue = '';
  }

  setFlowStepValueHandler() {
    const selectedNode = this.selectedNode ? this.selectedNode : '-Not Selected-';
    const selectedFlowStep = this.selectedFlow ? `${this.selectedFlow.name}:${selectedNode}` : selectedNode;
    this.close(selectedFlowStep);
  }

  checkIsStepSelected() {
    if (!this.flow) {
      return !this.selectedNode || this.selectedNode === 'NextStep' || this.selectedValue.step === this.selectedNode;
    } else {
      return !this.selectedNode || !this.selectedFlow;
    }
  }

  getStep() {
      const flowStep = this.selectedNode;

      if (flowStep !== undefined && flowStep !== null) {
      const flowNum = flowStep.replace('step', '');
      if (flowNum === 'start' || flowNum === 'NextStep') {
        return '';
      } else {
        return  flowNum;
      }
      }

      return '';

    }

}
